import { Arbitrary, constantFrom, nat, record, string } from 'fast-check';
import { DatiqFilterComparison } from './datiq-app.enum';
import { IDatiqFilter, IDatiqNumberRange } from './datiq-app.interface';

const endArb: Arbitrary<number> = nat();
const startArb: Arbitrary<number> = endArb.chain((end: number) => nat(end));

export const generateNumberRange: () => Arbitrary<IDatiqNumberRange> = () => {
    return record({
        start: startArb,
        end: endArb,
    });
};

export const generateFilter: () => Arbitrary<IDatiqFilter> = () => {
    return record({
        key: string(),
        comparison: constantFrom(
            DatiqFilterComparison.Equals,
            DatiqFilterComparison.GreaterThan,
            DatiqFilterComparison.GreaterThanOrEquals,
            DatiqFilterComparison.LessThan,
            DatiqFilterComparison.LessThanOrEquals,
            DatiqFilterComparison.NotEquals,
            DatiqFilterComparison.Unknown,
        ),
        value: nat(),
    });
};
